import { useRef, useEffect } from 'react';

/**
 * @param {Function} callback - Function to run
 * @param {number|null|undefined} delay - Delay in milliseconds. Interval pauses when null
 */

function useInterval(callback, delay) {
  var savedCallback = useRef(undefined);

  // Remember the latest callback.
  useEffect(function () {
    savedCallback.current = callback;
  });

  // Set up the interval.
  useEffect(function () {
    function tick() {
      var _savedCallback$curren;
      (_savedCallback$curren = savedCallback.current) === null || _savedCallback$curren === void 0 || _savedCallback$curren.call(savedCallback);
    }
    if (typeof delay === 'number') {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }
  }, [delay]);
}
export default useInterval;